import { generateItems } from 'domain/common';
import { Portfolio } from 'domain/lib';

const { actions, selectors, reducer } = generateItems('Portfolio', Portfolio);

export { actions, selectors, reducer };
